import { useEffect } from "react";

import { Destination, FormField } from "@prequel/react";
import { CopyToClipboard } from "@prequel/shared-components";

type ConstWrapperProps = {
  field: FormField;
  setDestinationField?: (key: keyof Destination, value: string | boolean | string[]) => void;
};
const ConstWrapper = ({ field, setDestinationField }: ConstWrapperProps) => {
  const fieldName = field.name;
  const fieldConst = field.const;

  useEffect(() => {
    if (
      (fieldName === "ssh_public_key" || fieldName === "public_key") &&
      setDestinationField &&
      typeof fieldConst === "string"
    ) {
      setDestinationField(fieldName, fieldConst);
    }
  }, [fieldConst, fieldName, setDestinationField]);

  if (!fieldConst) {
    return <></>;
  }

  // Don't display pksc8 comments when we render the key, but leave them in the copyable value
  const stringifiedValue =
    typeof field.const === "object" ? JSON.stringify(field.const, null, 2) : String(field.const ?? "");
  const truncatedValue = stringifiedValue
    .replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace("prequel-ssh-tunneling-public-key", "");

  return (
    <>
      <label className="block text-sm font-medium text-gray-700">{field.label}</label>
      {typeof field.const === "object" ? (
        <div
          className="
            mt-1 inline-flex w-full resize-y overflow-auto rounded-md border border-gray-300 bg-gray-50 py-2 pr-1 pl-3
            font-mono text-sm text-gray-500 shadow-sm
          "
        >
          <div className="mr-3 h-14 w-full whitespace-pre-wrap">{truncatedValue}</div>
          <CopyToClipboard textToCopy={stringifiedValue} className="sticky top-0 self-start" />
        </div>
      ) : (
        <div
          className="
            mt-1 inline-flex w-full rounded-md border border-gray-300 bg-gray-50 py-2 pr-1 pl-3 font-mono text-sm
            text-gray-500 shadow-sm
          "
        >
          <div className="mr-3 w-full truncate">{field.const}</div>
          <CopyToClipboard textToCopy={stringifiedValue} />
        </div>
      )}
      {field.description && (
        <p className="mt-2 text-xs whitespace-pre-line text-gray-400" id="description">
          {field.description}
        </p>
      )}
    </>
  );
};

export default ConstWrapper;
